import(/* webpackMode: "eager" */ "/lexoya/node_modules/next/dist/client/link.js");
